export var QuotaStatus;
(function (QuotaStatus) {
    QuotaStatus["QuotaStatusUnspecified"] = "QUOTA_STATUS_UNSPECIFIED";
    QuotaStatus["InQuota"] = "IN_QUOTA";
    QuotaStatus["SizeExceeded"] = "SIZE_EXCEEDED";
    QuotaStatus["ObjectCountExceeded"] = "OBJECT_COUNT_EXCEEDED";
    QuotaStatus["MaxResourcesExceeded"] = "MAX_RESOURCES_EXCEEDED";
    QuotaStatus["ExcludedFromQuota"] = "EXCLUDED_FROM_QUOTA";
    QuotaStatus["InQuotaOverridden"] = "IN_QUOTA_OVERRIDDEN";
})(QuotaStatus || (QuotaStatus = {}));
